import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ASSET_EXPIRATION_BADGE_CLASS_NAME = 'AssetExpirationBadge';
export const ASSET_EXPIRATION_BADGE_CLASS_SLOTS = ['root'] as const;

export type AssetExpirationBadgeClassSlot =
	(typeof ASSET_EXPIRATION_BADGE_CLASS_SLOTS)[number];

export interface AssetExpirationBadgeClasses {
	root: string;
}

export type AssetExpirationBadgeClassKey = keyof AssetExpirationBadgeClasses;

export const getAssetExpirationBadgeUtilityClass = (slot: string) =>
	generateUtilityClass(ASSET_EXPIRATION_BADGE_CLASS_NAME, slot);

export const assetExpirationBadgeClasses: AssetExpirationBadgeClasses =
	generateUtilityClasses(ASSET_EXPIRATION_BADGE_CLASS_NAME, ['root']);

export default assetExpirationBadgeClasses;
